import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-cancel-shortcode-lease-dialog',
  templateUrl: './cancel-shortcodelease-dialog.component.html',
  styleUrls: ['./cancel-shortcodelease-dialog.component.scss']
})
export class CancelShortCodeLeaseDialogComponent extends ScrBaseComponent implements OnInit {
  @Input() errorMessage?: string;


  public transferAgreement = false;
  public toAccountIdValue?: number;

  public display = false;
  @ViewChild('transferForm', { static: false }) transferForm!: NgForm;

  constructor(private shortCodesService: ShortCodesService,) { super(); }

  ngOnInit(): void {
    this.clearErrors();
  }

  resetForm()
  {
    delete this.toAccountIdValue;
    this.transferAgreement = false;
    this.transferForm.resetForm();
    this.transferForm.form.markAsPristine();
    this.clearMessages();
  }

  cancel() {
    this.display = false;
  }

  showDialog() {
    this.display = true;
  }



  closeDialog() {
    this.display = false;
  }
}